import { memo } from "react";

const AppJobApplicationIcon = ({ color = "#3069B2" }) => {
	return (
		<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0 3.78V17.37C0 19.46 1.75999 21.15 3.92999 21.15H8.72C9.16 21.15 9.50999 20.81 9.50999 20.39C9.50999 19.97 9.16 19.63 8.72 19.63H3.92999C2.62999 19.63 1.58 18.62 1.58 17.37V3.78C1.58 2.53 2.62999 1.52 3.92999 1.52H13.94C15.24 1.52 16.29 2.53 16.29 3.78V9.7C16.29 10.12 16.64 10.46 17.08 10.46C17.52 10.46 17.87 10.12 17.87 9.7V3.78C17.87 1.69 16.11 0 13.94 0H3.92999C1.75999 0 0 1.69 0 3.78Z"
				fill={color}
			/>
			<path
				d="M4.77048 5.28001H13.1105C13.5505 5.28001 13.9005 4.94001 13.9005 4.52001C13.9005 4.10001 13.5505 3.76001 13.1105 3.76001H4.77048C4.33048 3.76001 3.98047 4.10001 3.98047 4.52001C3.98047 4.94001 4.33048 5.28001 4.77048 5.28001Z"
				fill={color}
			/>
			<path
				d="M13.8907 8.43993C13.8907 8.01993 13.5407 7.67993 13.1007 7.67993H4.7607C4.3207 7.67993 3.9707 8.01993 3.9707 8.43993C3.9707 8.85993 4.3207 9.19993 4.7607 9.19993H13.1007C13.5407 9.19993 13.8907 8.85993 13.8907 8.43993Z"
				fill={color}
			/>
			<path
				d="M4.77048 11.6001C4.33048 11.6001 3.98047 11.9401 3.98047 12.3601C3.98047 12.7801 4.33048 13.1201 4.77048 13.1201H8.56047C9.00047 13.1201 9.35048 12.7801 9.35048 12.3601C9.35048 11.9401 9.00047 11.6001 8.56047 11.6001H4.77048Z"
				fill={color}
			/>
			<path
				d="M4.77048 15.51C4.33048 15.51 3.98047 15.85 3.98047 16.27C3.98047 16.69 4.33048 17.03 4.77048 17.03H8.56047C9.00047 17.03 9.35048 16.69 9.35048 16.27C9.35048 15.85 9.00047 15.51 8.56047 15.51H4.77048Z"
				fill={color}
			/>
			<path
				d="M15.1809 10.97C13.6809 10.97 12.4609 12.14 12.4609 13.59C12.4609 15.04 13.6809 16.21 15.1809 16.21C16.6809 16.21 17.9009 15.04 17.9009 13.59C17.9009 12.14 16.6809 10.97 15.1809 10.97ZM15.1809 14.69C14.5509 14.69 14.0409 14.2 14.0409 13.59C14.0409 12.98 14.5509 12.49 15.1909 12.49C15.8209 12.49 16.3309 12.98 16.3309 13.59C16.3309 14.2 15.8209 14.69 15.1809 14.69Z"
				fill={color}
			/>
			<path
				d="M11.1494 22.0001C11.5894 22.0001 11.9394 21.6601 11.9394 21.2401C11.9394 19.5201 13.3894 18.1301 15.1794 18.1301C16.9694 18.1301 18.4194 19.5201 18.4194 21.2401C18.4194 21.6601 18.7694 22.0001 19.2094 22.0001C19.6494 22.0001 19.9994 21.6601 19.9994 21.2401C19.9994 18.6801 17.8394 16.6101 15.1794 16.6101C12.5194 16.6101 10.3594 18.6801 10.3594 21.2401C10.3594 21.6601 10.7094 22.0001 11.1494 22.0001Z"
				fill={color}
			/>
		</svg>
	);
};

export default memo(AppJobApplicationIcon);
